// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"9715b7fd","513":"47c2cb52","703":"406c15b7","787":"e2758c1f"}[chunkId] + ".chunk.js";
};